import * as React from "react";
import { SegmentedControl as MantineSegmentedControl } from "@mantine/core";
import { useTheme } from "styled-components";
const SegmentedControl = ({
  autoContrast = false,
  className = void 0,
  data,
  defaultValue = void 0,
  disabled = false,
  onChange = void 0,
  value = void 0,
  radius = "xs",
  color = "info"
}) => {
  const theme = useTheme();
  return /* @__PURE__ */ React.createElement(
    MantineSegmentedControl,
    {
      color: color === "neutral" ? theme.colors.gray[100] : theme.colors.variant[color],
      autoContrast: color === "neutral" ? true : autoContrast,
      className,
      data,
      defaultValue,
      radius,
      disabled,
      value,
      onChange,
      styles: { label: { marginBottom: 0 } }
    }
  );
};
export default SegmentedControl;
